export default "__VITE_ASSET__CAFZ4JQw__"